export const AB_TEST_NAME = 'provider_full_onboarding_carousel_ev3131_20201207';
export const AB_TEST_PERCENT = 0.5;
